export default "__VITE_ASSET__D5yR8A9f__"